var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.658 3.987a67.8 67.8 0 0 0-6.68-.334c-1.32 0-2.64.067-3.96.2l-1.36.134M6.325 3.313l.146-.873c.107-.633.187-1.107 1.314-1.107H9.53c1.127 0 1.214.5 1.314 1.114l.146.866M13.225 6.093l-.433 6.714c-.074 1.046-.134 1.86-1.994 1.86h-4.28c-1.86 0-1.92-.814-1.993-1.86l-.433-6.714M7.545 11h2.22M6.992 8.333h3.333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgTrash as ReactComponent };